import { render, staticRenderFns } from "./news16.vue?vue&type=template&id=047b4e37&scoped=true&"
import script from "./news16.vue?vue&type=script&lang=js&"
export * from "./news16.vue?vue&type=script&lang=js&"
import style0 from "./news16.vue?vue&type=style&index=0&id=047b4e37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b4e37",
  null
  
)

export default component.exports